import { useHistory } from "react-router-dom";
import { defaultProfileImage } from "../../../../../../utils/constants";
import { handleImageErrorGray, handleImageErrorProfile } from "../../../../../../utils/UtilsFiles";

type Props = {
    experience?: any;
    conversation?: any;
}

export const MessagesExperienceLandInfo = ({ experience, conversation }: Props) => {
    const history = useHistory();
    const title = experience?.title || "Experience Title";
    const coverImage = experience?.coverImage || experience?.cover_image || "https://i.pravatar.cc/370";
    const isHost = conversation?.isHost ?? conversation?.is_host;
    const hostName = isHost ? "You" : (experience?.host?.name || "Host Name");
    const hostAvatar = experience?.host?.avatar || defaultProfileImage;
    const categories = experience?.categories || [];
    
    const experienceId = experience?.id || experience?.experienceId || experience?.experience_id;

    const handleRedirect = () => {
        if (experienceId) {
            history.push(`/experience/detail/${experienceId}`);
        }
    };

    return (
        <div className="messages-info-experience">
            <div className="degrate"></div>
            
            <div className="labels">
                <div className="d-flex flex-row justify-content-center align-items-center" style={{ gap: '10px', padding: '5px 0' }}>
                    <div className="author">
                        <img src={hostAvatar} onError={handleImageErrorProfile} alt="Host Avatar" />
                        <span>{hostName}</span>
                    </div>
                </div>
                <h5 
                    style={{ margin: '0', marginTop: '5px', cursor: 'pointer' }} 
                    className="cursor-pointer" 
                    onClick={handleRedirect}
                >
                    {title}
                </h5>
                <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '20px', gap: '20px' }}>
                    {categories.map((cat: string, index: number) => (
                        <span key={index} className="tag">{cat}</span>
                    ))}
                </div>
            </div>

            <img 
                src={coverImage} onError={handleImageErrorGray}
                alt="Cover" 
                style={{ cursor: 'pointer' }} 
                className="cursor-pointer" 
                onClick={handleRedirect} 
            />
        </div>
    )
}